const repairEntitiesOrder = (sortableByField, sortedEntities) => {
  for (let i = 0, len = sortedEntities.length; i < len; i++) {
    const entity = sortedEntities[i];
    const orderField = entity.getRelativeSingleField(sortableByField);
    if (orderField.value !== i) {
      orderField.updateValue(i);
    }
  }
};
export {
  repairEntitiesOrder
};
//# sourceMappingURL=repairEntitiesOrder.js.map
